export default __webpack_public_path__ + "static/media/ozoneLogo.824d032a.svg";